// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","BrandListItem__icon":"vo_a bih_ke","BrandListItem__name":"vo_b bih_vp"};